// Campaign policy is independent of the paid-ad signup cookies and acquisition UTMs.
export const AUTHOR_NATION = Object.freeze({
  id: "author-nation-2026",
  name: "Author Nation 2026",
  path: "/event-bonus?campaign=author-nation-2026",
  entryPath: "/app?conference=author-nation-2026",
  timeZone: "America/Los_Angeles",
  startsAt: "2026-11-09T08:00:00.000Z",
  eventEndsAt: "2026-11-15T08:00:00.000Z",
  attributionEndsAt: "2026-11-22T08:00:00.000Z",
  paymentPolicy: "required",
});

export const CONFERENCE_COOKIE = "conference_entry";
export const CONFERENCE_PLACEMENT_COOKIE = "conference_placement";
export const CONFERENCE_COOKIE_OPTIONS = { path: "/", maxAge: 60 * 60 * 24 * 14, sameSite: "lax" };

export function getConferenceCampaign(id) {
  return id === AUTHOR_NATION.id ? AUTHOR_NATION : null;
}

export function conferenceDate(value) {
  return value?.toDate ? value.toDate() : new Date(value);
}

export function conferenceAcceptsEntries(id, now = new Date()) {
  const campaign = getConferenceCampaign(id);
  // Pre-event entries are allowed for rehearsal, but excluded from live reporting.
  return !!campaign && now < new Date(campaign.attributionEndsAt);
}

export function normalizeConferencePlacement(value) {
  return typeof value === "string" && /^[a-zA-Z0-9_-]{1,64}$/.test(value) ? value : "booth";
}

// Match the app home route's optional trailing slash in every entry path.
export function isConferenceEntryPath(pathname) {
  return pathname === "/app" || pathname === "/app/";
}

export function conferenceSignInNext(pathname, search) {
  const params = new URLSearchParams(search);
  const campaign = getConferenceCampaign(params.get("conference"));
  return isConferenceEntryPath(pathname) && campaign
    ? `${campaign.entryPath}&utm_content=${normalizeConferencePlacement(params.get("utm_content"))}`
    : undefined;
}

export function requiresConferencePayment(data) {
  return getConferenceCampaign(data?.conferenceCampaign?.id)?.paymentPolicy === "required"
    && data?.conferenceCampaign?.paymentRequired === true;
}

export function conferenceAccountCategory(data, now = new Date()) {
  if (data?.hasPaid) return conferenceDate(data.currentPeriodEnd) > now ? "subscriber" : "former_subscriber";
  return "trial";
}

export function buildConferenceEnrollment({ userId, category, placement, now = new Date(), isTest = false }) {
  return {
    userId,
    campaignId: AUTHOR_NATION.id,
    category,
    placement: normalizeConferencePlacement(placement),
    enrolledAt: now,
    attributionEndsAt: new Date(AUTHOR_NATION.attributionEndsAt),
    isTest: isTest || now < new Date(AUTHOR_NATION.startsAt),
    period: now < new Date(AUTHOR_NATION.eventEndsAt) ? "event" : "follow_up",
    firstPayment: null,
  };
}

export function qualifiesConferenceConversion(enrollment, payment) {
  const paidAt = conferenceDate(payment.paidAt);
  return !enrollment.isTest && payment.isTest !== true && payment.amountMinor > 0
    && ["new", "trial"].includes(enrollment.category)
    && paidAt >= conferenceDate(enrollment.enrolledAt)
    && paidAt >= new Date(AUTHOR_NATION.startsAt)
    && paidAt < conferenceDate(enrollment.attributionEndsAt);
}
